import { CircularProgress, Typography } from "@mui/material";
import json5 from "json5";
import lodash from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import MUIMultiSelect from "../../Component/UI/MUIMultiSelect/MUIMultiSelect";
import RadioGroup from "../../Component/UI/RadioGroup/RadioGroup";
import Warning from "../../Component/Warning/Warning";
import { fetchGpt4API } from "../../services/apiService";
import { DefaultSet, LLM_OPTIONS, OVERVIEW_LLM_LABELS } from "../../utils/constant";
import MUISelect from "../../Component/UI/MUISelect/MUISelect";
import {
  validateBrandInputValue,
  validateProductInputValue,
} from "../../utils/helpers";
import Suggestions from "./Suggestions/Suggestions";
import TextInput from "./../../Component/UI/TextInput/TextInput";
import classes from "./Form.module.css";
import { DiscoveryContext } from "./discovery-context";
import useGeneratePreCategoryDimensions from "./useGeneratePreCategoryDimensions";
import useGenerateProductTaxonomies from "./useGenerateProductTaxonomies";
import useTopUserProducts from "./useTopUserProducts";
import MUIMultiTextInput from "../../Component/UI/MUIMultiTextInput/MUIMultiTextInput";
import MUIMultiItemBox from "../../Component/UI/MUIMultiItemBox/MUIMultiItemBox";
import useHistory from "./History/useHistory";
import History from "./History/HistoryV2"
import Modal from "../../Component/Modal/Modal";
import MUIIconButton from "../../Component/UI/MUIIconButton/MUIIconButton";
import { SettingsOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../context/auth-context";
import SettingsModal from "./BrandAuditSetting/Setting";
import { ENTITY_LABELS, getEntityLabel } from "../../utils/labelMapping";


const RADIO_OPTIONS = [
  {
    value: "brand",
    label: `${ENTITY_LABELS.Brand}`,
  },
  {
    value: "product",
    label: `${ENTITY_LABELS.Product}`,
  },
];

export default function Form({
  onSubmit,
  onTypeChanged = () => { },
  onReset = () => { },
  warningText,
  setWarningText = () => { },
  cancelTransaction,
  discoveryTypeChange,
  setDiscoveryTypeChange = () => { },
  stopPolling = () => { },
  startPolling = () => { },
  setCancelTransaction = () => { },
  setLaunchType = () => { },
  setDomain = () => { },
  domain,
  launchType = null,
  setIsAuditRunning = () => { },
  setActiveTab = () => { },
  loadBrandAudit,
  isAuditRunning = false,
  processRetry = false
}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const userMetricSetting = useSelector((store) => store.userSet);
  const defaultUseMetricSettingID = userMetricSetting.brandAuditMetricSettingId;
  const [loading, setLoading] = useState(false);
  const [updatedKeyPlayers, setUpdatedKeyPlayers] = useState({});
  const [brand, setBrand] = useState("");
  const [llm, setLLM] = useState(["gpt-5.1"]);
  const [primaryLLM, setPrimaryLLM] = useState("gpt-5.1");
  const [category, setCategory] = useState([]);
  const [market, setMarket] = useState(["General Market"]);
  const [persona, setPersona] = useState([{ title: "General Profile", description: "General Profile" }]);
  const [metricSettingId, setMetricSettingId] = useState(
    defaultUseMetricSettingID
  );
  const [customCompetitors, setCustomCompetitors] = useState({})
  const [customCompetitorValues, setCustomCompetitorValues] = useState({})
  const [selectedBrandsProducts, setSelectedBrandProducts] = useState({});
  const [aICategories, setAICategories] = useState([]);
  const [isMock, setIsMock] = useState(false);
  const [rbiType, setRbiType] = useState(discoveryCtx.state?.rbiType || "propensityToRecommend");
  const [keywords, setKeywords] = useState(discoveryCtx.state?.keywords?.length > 0 ? discoveryCtx.state.keywords : ["Top", "Best", "Most Recommended"]);
  const [isCategorySuggestionLoading, setCategorySuggestionLoading] =
    useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [launchMessage, setLaunchMessage] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [competitorsData, setCompetitorsData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [competitorWarning, setCompetitorWarning] = useState("");
  const [showHistoryModal, setShowHistoryModal] = useState(false)
  const categoryChangeTimerRef = useRef();
  const {
    loading: keyPlayersLoading,
    keyPlayers,
    setKeyPlayers,
    getBrandOrProductSuggestions,
  } = useTopUserProducts();
  const { deleteHistory, getHistory } = useHistory(discoveryTypeChange);
  const { page } = discoveryCtx;
  const { generateProductTaxonomies, custom_taxonomies } =
    useGenerateProductTaxonomies();
  const [personaSettings, setPersonaSettings] = useState({
    applyPersonaToAllCategory: false,
    applyPersonaToAllMarkets: false
  });
  const { generatePreCategoryDimensions } = useGeneratePreCategoryDimensions();
  const [categoryWiseMetric, setCategoryWiseMetric] = useState({});
  const [categoryMetricChange, setCategoryWiseMetricChange] = useState([]);
  const [showConfigModal, setShowConfigModal] = useState(false);
  const abortControllerRef = useRef(null);
  const isFinalTransactionCompleted =
    discoveryCtx?.state.finalTransactionStatus === "COMPLETED" ||
    discoveryCtx?.state.finalTransactionStatus === "RETRY";
  const shouldResetOnDelete =
    discoveryCtx?.state?.transactionId === discoveryCtx?.state?.finalTransactionId ||
    (discoveryCtx?.state?.transactionStatus !== "RUNNING" && discoveryCtx?.state?.launchRecord?.length === 1);
  const testLLMModel = process.env.REACT_APP_LOWCOST_MODEL;
  const auditTransactionId = discoveryCtx.state.id;
  const currentTabName = discoveryCtx?.state?.launchRecord
    ?.find(item => item?.transactionId === auditTransactionId)
    ?.name;

  let isDisabled = discoveryCtx?.loading || isFinalTransactionCompleted;
  const isTransactionPending = discoveryCtx?.state.transactionStatus === "PENDING";

  useEffect(() => {
    if (discoveryCtx?.state?.transactionId) return;
    setMetricSettingId(defaultUseMetricSettingID);
  }, [defaultUseMetricSettingID]);

  useEffect(() => {
    if (!category || auditTransactionId) return;
    if (categoryChangeTimerRef.current) {
      clearTimeout(categoryChangeTimerRef.current);
    }
    category.forEach((currentCategory) => {
      if (!custom_taxonomies[currentCategory]) {
        categoryChangeTimerRef.current = setTimeout(() => {
          if (
            discoveryCtx.type === "category" ||
            discoveryCtx.type === "product"
          ) {
            generateProductTaxonomies(currentCategory);
          }
          // generatePreCategoryDimensions(category);
        }, 1000);
      }
    });
    discoveryCtx.updateProductPrefs([]);
  }, [category, llm, brand]);

  useEffect(() => {
    if (!brand || discoveryCtx.is_resetFormState) {
      setAICategories([]);
      return;
    }
    if (discoveryCtx.state.finalTransactionStatus === "COMPLETED") return;
    async function getCategoryAISuggestions() {
      setCategorySuggestionLoading(true);
      setAICategories([]);
      try {
        const prompt = `For the brand or product name '${brand}', list the **top 5 brand product categories** describing its market segment, primary use, or type. **Rules:** - Use only broad functional or market classifications. - Exclude model names, series names, version numbers, and product lines. - Categories must be widely recognized without brand knowledge. - Focus on role, form factor, target market, or core features. **Output (strict):** {\"categories\": [\"Category1\", \"Category2\", \"Category3\", \"Category4\", \"Category5\"]} No explanations or extra text.`;
        let result = await fetchGpt4API(
          prompt,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          "Discovery"
        );
        result = result["GPT-4"][0];

        if (result) {
          let resultArray = json5.parse(result);
          const normalize = (str) => str.toLowerCase().replace(/\s+/g, "");

          const merged = [
            ...discoveryCtx?.category,
            ...resultArray?.categories.filter(
              (c) =>
                !discoveryCtx?.category.some(
                  (cat) => normalize(cat) === normalize(c)
                )
            ),
          ];

          const finalArray = merged
            .slice(0, 5)
            .map((o) => ({ name: o, value: o }));
          setAICategories(finalArray);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setCategorySuggestionLoading(false);
      }
    }
    const debouncedFunction = lodash.debounce(getCategoryAISuggestions, 2000);
    debouncedFunction();
    return () => debouncedFunction.cancel();
  }, [brand, discoveryCtx.formData]);

  function mergeLatestCustomCompetitorIntoOptions(
    options = [],
    entity,
    category,
    {
      valueKey = "value",
      categoryStateSetter,
    } = {}
  ) {
    if (!entity?.[valueKey]) return options;

    const alreadyExistsInOptions = options.some(
      (opt) => opt[valueKey] === entity[valueKey]
    );

    if (alreadyExistsInOptions) {
      return { mergedOptions: options, added: false };
    }

    if (categoryStateSetter && category) {
      categoryStateSetter((prev) => {
        const updated = { ...prev };
        const list = updated[category] || [];

        const alreadyExistsInCategory = list.some(
          (item) => item[valueKey] === entity[valueKey]
        );

        if (!alreadyExistsInCategory) {
          updated[category] = [...list, entity];
        }

        return updated;
      });
    }

    return {
      mergedOptions: [...options, entity],
      added: true,
    };
  }
  function handleProductBrandSelection(players, category, options) {
    let mergedOptions = options
    if (customCompetitorValues?.domain) {
      const result = mergeLatestCustomCompetitorIntoOptions(
        options,
        {
          value: players[players.length - 1],
          name: players[players.length - 1],
          domain: customCompetitorValues?.domain || "example.com",
          variants: customCompetitorValues?.variants || []
        },
        category,
        {
          categoryStateSetter: setCustomCompetitors,
        }
      );
      if (!result.added) {
        setCustomCompetitorValues({});
        toast.warning("This competitor is already added for this category.");
        return;
      }

      mergedOptions = result.mergedOptions;
      setCustomCompetitorValues({});
    }
    let categoryName = category;
    let maxProductBrands = 3;
    let message = "Only 3 competitors are allowed";
    setSelectedBrandProducts((prevPlayers) => {
      let competitor = { ...competitorsData };
      if (!competitor[categoryName]) {
        competitor[categoryName] = [];
      }
      let prevPlayersUpdated = { ...prevPlayers };
      let updatedPlayers = players.map((player) => {
        const matched = mergedOptions.find(
          (item) => item.name === player
        );
        return {
          value: player,
          name: player,
          domain: matched?.domain || "example.com",
          variants: matched?.variants ?? [],
        };
      });
      if (updatedPlayers.length > maxProductBrands) {
        toast.warn(message);
        updatedPlayers = updatedPlayers.slice(0, maxProductBrands);
        setCompetitorsData({ ...prevPlayersUpdated });
        return prevPlayers;
      } else {
        prevPlayersUpdated[categoryName] = updatedPlayers;
        competitor[categoryName] = updatedPlayers;
        setCompetitorsData({ ...prevPlayersUpdated });
        return prevPlayersUpdated;
      }
    });
  }

  function handleDeleteBrandProduct(itemName, categoryName) {
    setSelectedBrandProducts((prevBrandProducts) => {
      prevBrandProducts[categoryName] = [
        ...prevBrandProducts[categoryName],
      ].filter((item) => item.name != itemName);
      return prevBrandProducts;
    });

    let updatedCompetitors = [...competitorsData[categoryName]];
    updatedCompetitors = updatedCompetitors.filter(
      (comp) =>
        comp.name.toString().toLowerCase() !== itemName.toString().toLowerCase()
    );

    setCompetitorsData({
      ...competitorsData,
      [categoryName]: updatedCompetitors,
    });
  }
  async function checkIfInputOrProductValid(input, isProduct = false, {
    setLoadingState = () => { },
    setErrorMessage = () => { },
    errorText,
    isCustomCompetitor = false,
  } = {},
    category = "") {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;
    setLoadingState(true);
    setErrorMessage("");

    try {
      const validateFn = isProduct
        ? validateProductInputValue
        : validateBrandInputValue;

      const response = await validateFn(input, controller.signal, category);

      // Stop if request was aborted
      if (controller.signal.aborted) return;

      const data = response?.data?.data;

      const domain = data?.domain || "example.com";
      const variants = (data?.variants || []).map((variant) => ({
        id: variant,
        name: variant,
        active: true,
      }));
      const isValid = data?.ans === "Yes";
      if (isValid) {
        if (!isCustomCompetitor) {
          setDomain(domain);
        } else {
          setCustomCompetitorValues({ domain, variants });
        }
      } else {
        setErrorMessage(errorText);
      }

    } catch (error) {
      // Ignore abort errors
      if (error.name !== "AbortError") {
        console.error("Error while validating input", error);
      }
    } finally {
      // Always stop loading unless aborted
      if (!controller.signal.aborted) {
        setLoadingState(false);
      }
    }
  }

  const debouncedValidation = useRef(
    lodash.debounce((value, discoveryTypeChange, setLoadingState, setErrorMessage, errorText, isCustomCompetitor, category) => {
      if (!value?.trim()) return;

      checkIfInputOrProductValid(
        value,
        discoveryTypeChange === "product",
        { setLoadingState, setErrorMessage, errorText, isCustomCompetitor },
        category,
      );
    }, 1000)
  ).current;


  function handleBrandInputChange(e) {
    const errorText = `The ${discoveryTypeChange} or category name appears to be incorrect. This may impact the Brand Index report.`
    const value = e.target.value;
    setBrand(e.target.value);
    resetState();
    setCategory([]);
    setKeyPlayers({});
    setSelectedBrandProducts({});
    setUpdatedKeyPlayers({});
    setCustomCompetitors({})
    debouncedValidation(value, discoveryTypeChange, setLoading, setWarningText, errorText);
  }


  function resetState() {
    // discoveryCtx.updateAbortLaunch(true);
    // discoveryCtx.updatedLaunched(false);
    discoveryCtx.updateId(null);
  }

  function handleDiscoveryTypeChange(value) {
    discoveryCtx.resetState();
    onTypeChanged(value);
    discoveryCtx.updateType(value);
    setDiscoveryTypeChange(value);
    setBrand("");
    setCategory([]);
    setLLM(["gpt-5.1"]);
    setPrimaryLLM("gpt-5.1");
    setMetricSettingId(defaultUseMetricSettingID);
    setKeyPlayers({});
    setSelectedBrandProducts({});
    onReset();
    setMarket(["General Market"]);
    setRbiType("propensityToRecommend");
    setPersonaSettings({
      applyPersonaToAllCategory: false,
      applyPersonaToAllMarkets: false
    });
    setPersona([{ title: "General Profile", description: "General Profile" }]);
    setIsAuditRunning(false);
  }
  useEffect(() => {
    if (!llm.includes(primaryLLM)) {
      const next = llm[0] || "";
      setPrimaryLLM(next);
      // discoveryCtx.updatePrimaryLLM(next);
    }
  }, [llm]);

  useEffect(() => {
    if (auditTransactionId && discoveryCtx.formData) {
      const normalizedLLM =
        Array.isArray(discoveryCtx.llm) &&
          discoveryCtx.llm.length === 1 &&
          discoveryCtx.llm[0] === testLLMModel
          ? ["gpt-5.1"]
          : discoveryCtx.llm;
      setUpdatedKeyPlayers({});
      setCustomCompetitors({});
      setKeyPlayers({});
      setBrand(discoveryCtx.entity);
      setCategory(discoveryCtx.category);
      setCategoryWiseMetric(
        discoveryCtx.state?.metricSettingObject?.categoryWiseMetric ?? {}
      );
      setPersonaSettings(discoveryCtx.state.personaSettings)
      setMarket(discoveryCtx.markets);
      setPersona(discoveryCtx.persona)
      setLLM(normalizedLLM);
      setPrimaryLLM(
        discoveryCtx.primary_llm === testLLMModel
          ? "gpt-5.1"
          : discoveryCtx.primary_llm
      );
      setMetricSettingId(discoveryCtx.customTemplateID);
      setRbiType(discoveryCtx.state.rbiType || "propensityToRecommend");
      setKeywords(discoveryCtx.state?.keywords?.length > 0 ? discoveryCtx.state.keywords : ["Top", "Best", "Most Recommended"]);
      setSelectedBrandProducts(discoveryCtx.competitors);
      setCompetitorsData(discoveryCtx.competitors);
      if (discoveryCtx.state.finalTransactionStatus != "COMPLETED") {
        updateCompetitorsByCategories(discoveryCtx.category);
      }
      discoveryCtx.updateFormData(false);
    }
  }, [discoveryCtx.formData]);
  useEffect(() => {
    if (
      (cancelTransaction && !discoveryCtx.abort_launch) ||
      discoveryCtx.is_resetFormState
    ) {
      const normalizedLLM =
        Array.isArray(discoveryCtx.llm) &&
          discoveryCtx.llm.length === 1 &&
          discoveryCtx.llm[0] === testLLMModel
          ? ["gpt-5.1"]
          : discoveryCtx.llm;
      setBrand(discoveryCtx.entity);
      setCategory(discoveryCtx.category);
      setAICategories([]);
      setMarket(["General Market"]);
      setPersonaSettings({
        applyPersonaToAllCategory: false,
        applyPersonaToAllMarkets: false
      });
      setPersona([{ title: "General Profile", description: "General Profile" }]);
      setLLM(normalizedLLM);
      setPrimaryLLM("gpt-5.1");
      setMetricSettingId(defaultUseMetricSettingID);
      setCancelTransaction(false);
      setIsAuditRunning(false);
      discoveryCtx.resetFormState(false);
      setRbiType(discoveryCtx.state.rbiType || "propensityToRecommend");
      setKeywords(discoveryCtx.state?.keywords?.length > 0 ? discoveryCtx.state.keywords : ["Top", "Best", "Most Recommended"]);
    }
  }, [
    cancelTransaction,
    discoveryCtx.abort_launch,
    discoveryCtx.is_resetFormState,
  ]);

  const cancelTransactionRecord = () => {
    stopPolling();
    setCancelTransaction(true);
    discoveryCtx.updateAbortLaunch(true);
  };

  const debounceLaunch = lodash.debounce(async function () {
    if ((!brand && discoveryTypeChange !== "category") || !category || !llm) {
      toast.warn("Please fill all required fields");
      return;
    }

    if (
      discoveryTypeChange === "category" &&
      (!discoveryCtx.location ||
        !discoveryCtx.occupation ||
        discoveryCtx.attributes.length === 0)
    ) {
      toast.warn("Please fill all required fields");
      return;
    }
    if (!keywords || keywords.length === 0) {
      toast.warn("Please select at least one rank attribute");
      return;
    }
    setLaunchMessage(false);
    setIsChanged(false);
    if (launchType === "test") {
      setLLM(["gpt-5.1"]);
      setPrimaryLLM("gpt-5.1");
      onSubmit({
        brand,
        category,
        market,
        persona,
        llm: [testLLMModel],
        discoveryTypeChange,
        domain,
        isMock,
        primaryLLM: testLLMModel,
        competitorsData,
        metricSettingId,
        categoryWiseMetric,
        rbiType,
        personaSettings,
        keywords
      });
    } else if (launchType === "final") {
      // use user-selected LLMs
      onSubmit({
        brand,
        category,
        market,
        persona,
        llm,
        discoveryTypeChange,
        domain,
        isMock,
        primaryLLM,
        competitorsData,
        metricSettingId,
        categoryWiseMetric,
        rbiType,
        personaSettings,
        keywords
      });
    }

    setLaunchType(null);
  }, 1000);
  const hasRequiredCompetitors =
    Object.keys(competitorsData).length > 0 &&
    Object.keys(competitorsData).every((categoryName) => {
      const competitors = competitorsData[categoryName] || [];
      return competitors.length === 3 || categoryName === "default";
    });
  const hasRequiredLLMs = llm && llm.length >= 1;

  const renderAllCompetitors = () => {
    return category?.map((record) => {
      return renderCompetitors(record);
    });
  };

  const renderCompetitors = (categoryName) => {
    const normalize = (str = "") => str.toLowerCase().replace(/\s+/g, "");
    const competitorOptions = updatedKeyPlayers[categoryName] ?? [];
    const contextData =
      competitorsData[categoryName]?.map((player) => ({
        ...player,
        value: player.name,
        name: player.name,
      })) ?? [];

    const contextNames = new Set(contextData.map((c) => normalize(c.name)));

    const merged = [
      ...contextData,
      ...competitorOptions.filter((c) => !contextNames.has(normalize(c.name))),
    ];
    const customList = Array.isArray(customCompetitors?.[categoryName])
      ? customCompetitors[categoryName]
      : [];

    let options = merged.slice(0, 8);
    // Merge custom competitors without duplicates
    const existingNames = new Set(options.map((opt) => normalize(opt.name)));
    const uniqueCustomList = customList.filter((custom) => !existingNames.has(normalize(custom.name)));
    options = [...options, ...uniqueCustomList]
    return (
      <div style={{ flex: 1 }}>
        <MUIMultiSelect
          loading={keyPlayersLoading}
          disabled={discoveryCtx?.loading || isFinalTransactionCompleted}
          fullWidth={true}
          customWidth={classes.fullWidth}
          allowCustomOption={true}
          optionValue={""}
          label={`${categoryName} Competitors `}
          value={
            selectedBrandsProducts[categoryName]?.map((obj) => obj.name) || []
          }
          // shouldShowValue={false}
          options={
            discoveryCtx?.loading || isFinalTransactionCompleted
              ? []
              : options
          }
          allowSettingPrimary={false}
          onChange={(e) => {
            handleProductBrandSelection(e, categoryName, options);
          }}
          onCustomConfirm={(finalValue) => {
            if (!finalValue) {
              setCustomCompetitorValues({});
            }

          }}
          modalValidation={{
            modalLoading,
            errorMessage: competitorWarning,
            errorTitle: "Mismatched brand/product or category",
            setErrorMessage: setCompetitorWarning,
            onCustomInputChange: (inputValue) => {
              debouncedValidation(
                inputValue,
                discoveryTypeChange,
                setModalLoading,
                setCompetitorWarning,
                `Please note, Entered brand/product doesn't belong to ${categoryName} category.`,
                true,
                categoryName
              );
            },
          }}
        />
        {competitorsData.length <= 3 && (
          <Typography
            color="textDisabled"
            variant="caption"
            sx={{ fontSize: "8px" }}
          >
            Select{" "}
            {discoveryTypeChange === "category"
              ? "key players "
              : "competitors "}
            <Typography
              color="error"
              variant="caption"
              sx={{ fontSize: "8px" }}
            >
              ({discoveryTypeChange === "category" ? `upto 4` : `Exactly 3`})
            </Typography>
          </Typography>
        )}
      </div>
    );
  };

  useEffect(() => {
    //  const hasCommon  = JSON.stringify([...discoveryCtx.category].sort()) === JSON.stringify([...category].sort())
    //   if (hasCommon) return
    let updatedKeyPlayersObj = {};
    category.forEach((cat) => {
      if (keyPlayers[cat]) {
        updatedKeyPlayersObj[cat] = keyPlayers[cat].map((player) => ({
          ...player,
          value: player.name,
          name: player.name,
        }));
      }
    });
    setUpdatedKeyPlayers(updatedKeyPlayersObj);

    let updatedSelectedBrandsProducts = {};
    category.forEach((cat) => {
      if (
        selectedBrandsProducts[cat] &&
        selectedBrandsProducts[cat].length > 0
      ) {
        updatedSelectedBrandsProducts[cat] = selectedBrandsProducts[cat];
      } else if (keyPlayers[cat] && keyPlayers[cat].length > 0) {
        updatedSelectedBrandsProducts[cat] = keyPlayers[cat].slice(0, 3) || [];
      }
    });
    setSelectedBrandProducts(updatedSelectedBrandsProducts);
    setCompetitorsData(updatedSelectedBrandsProducts);
  }, [keyPlayers, category]);

  function handleDeleteMarket(marketToDelete) {
    const updatedMarket = market.filter(
      (marketName) => marketName !== marketToDelete
    );
    setMarket(updatedMarket);
  }
  const handlePrimaryLLMChange = (value) => {
    setPrimaryLLM(value);
  };

  function getNextAuditAfterDelete({
    launchRecord = [],
    deletedTransactionId
  }) {
    if (shouldResetOnDelete) {
      return {
        shouldLoadNext: false,
        nextTransactionId: discoveryCtx?.state?.isFinalTransactionId,
      };
    }

    const index = launchRecord.findIndex(
      r => r.transactionId === deletedTransactionId
    );

    // if record not found, just return original
    if (index === -1) {
      return launchRecord;
    }

    const deletedRecord = launchRecord[index];
    const isLastRecord = index === launchRecord.length - 1;

    // remove the deleted record
    const updatedRecords = launchRecord.filter(
      r => r.transactionId !== deletedTransactionId
    );

    // if deleted record was last and there is still at least one record left
    if (isLastRecord && updatedRecords.length > 0) {
      const lastIndex = updatedRecords.length - 1;

      updatedRecords[lastIndex] = {
        ...updatedRecords[lastIndex],
        totalTestAudit: deletedRecord.totalTestAudit
      };
    }

    // Prefer NEXT record
    let nextRecord = launchRecord[index + 1];

    // If next doesn't exist → use PREVIOUS
    if (!nextRecord) {
      nextRecord = launchRecord[index - 1];
    }

    return {
      shouldLoadNext: true,
      nextTransactionId: nextRecord?.transactionId ?? null,
      updatedRecords,
      isUpdateFormData: isLastRecord && isAuditRunning
    };
  }


  async function deleteTransaction() {
    const {
      shouldLoadNext,
      nextTransactionId,
      updatedRecords,
      isUpdateFormData
    } = getNextAuditAfterDelete({
      launchRecord: discoveryCtx?.state?.launchRecord,
      deletedTransactionId: auditTransactionId
    });
    setShowDeleteDialog(false);
    await deleteHistory(auditTransactionId);
    setIsAuditRunning(false);
    stopPolling();
    if (discoveryCtx?.state?.launchRecord?.length === 1 && discoveryCtx?.state?.transactionStatus === "RUNNING") {
      // single test case if audit is in running state
      discoveryCtx.resetState();
      getHistory(page);
      return;
    } else if (!shouldLoadNext) {
      // FINAL audit
      discoveryCtx.resetState();
      setBrand("");
      setCategory([]);
      setLLM(["gpt-5.1"]);
      setPrimaryLLM("gpt-5.1");
      setMetricSettingId(defaultUseMetricSettingID);
      setKeyPlayers({});
      setSelectedBrandProducts({});
      onReset();
      setMarket(["General Market"]);
      setRbiType("propensityToRecommend");
      setPersonaSettings({
        applyPersonaToAllCategory: false,
        applyPersonaToAllMarkets: false
      });
      setPersona([{ title: "General Profile", description: "General Profile" }]);
      getHistory(page);
      return;
    }
    // load next test audit/FinalAudit
    discoveryCtx.updateLaunchRecord(updatedRecords);
    const transactionIdIndex = updatedRecords.findIndex(
      record => record.transactionId === nextTransactionId
    );
    setActiveTab(transactionIdIndex);
    loadBrandAudit(nextTransactionId, discoveryCtx?.type, user?.user_role?.user_id, true, true, !isUpdateFormData);
    // getHistory(page);
  }


  const updateCompetitorsByCategories = (categories) => {
    let newCompetitors = {};
    let newKeyPlayers = {};
    categories.forEach((category) => {
      if (
        !updatedKeyPlayers[category] ||
        updatedKeyPlayers[category].length === 0 ||
        discoveryCtx.formData
      ) {
        newCompetitors[category] = [];
        newKeyPlayers[category] = [];
        let type = discoveryCtx.type === "product" ? "product" : "brand";
        getBrandOrProductSuggestions(
          type,
          category,
          null,
          [],
          null,
          market[0],
          brand
        );
      } else {
        newCompetitors[category] = updatedKeyPlayers[category];
        newKeyPlayers[category] = updatedKeyPlayers[category];
      }
    });
    setCompetitorsData(newCompetitors);
    setUpdatedKeyPlayers(newKeyPlayers);
  };

  const normalizeCompetitors = (data) => {
    const result = {};
    Object.keys(data || {})
      .filter((key) => key !== "default") // 👈 skip "default"
      .sort()
      .forEach((key) => {
        // Extract only normalized competitor names
        result[key] = (data[key] || [])
          .map((comp) => comp?.name?.toLowerCase().replace(/\s+/g, "") || "")
          .sort();
      });
    return result;
  };
  const compareFormData = () => {
    if (!discoveryCtx?.state?.transactionId) return false;

    const original = {
      market: discoveryCtx.markets || [],
      category: discoveryCtx.category || [],
      competitor: normalizeCompetitors(discoveryCtx.competitors || {}),
      customTemplateID: Number(discoveryCtx.customTemplateID),
      persona: discoveryCtx.persona || []
    };

    const current = {
      market,
      category,
      competitorsData: normalizeCompetitors(competitorsData || {}),
      customTemplateID: Number(metricSettingId),
      persona
    };

    const isMarketSame =
      JSON.stringify([...original.market].sort()) ===
      JSON.stringify([...current.market].sort());

    const isCategorySame =
      JSON.stringify([...original.category].sort()) ===
      JSON.stringify([...current.category].sort());

    const isPersonaSame =
      JSON.stringify([...original.persona].sort()) ===
      JSON.stringify([...current.persona].sort());

    const isCompetitorSame =
      JSON.stringify(original.competitor) ===
      JSON.stringify(current.competitorsData);

    const isCustomTemplateIDSame =
      String(original.customTemplateID) === String(current.customTemplateID);

    const isSame =
      isMarketSame &&
      isCategorySame &&
      isCompetitorSame &&
      isPersonaSame &&
      isCustomTemplateIDSame;

    return !isSame;
  };

  useEffect(() => {
    const hasChanged = compareFormData();
    setIsChanged(hasChanged);
  }, [category, market, persona, competitorsData, metricSettingId, discoveryCtx.category]);

  useEffect(() => {
    if (discoveryCtx?.state?.transactionId) return;

    if (!category?.length) {
      setCategoryWiseMetricChange([]);
      return setCategoryWiseMetric({});
    }

    /*
    * when we remove category and again add it we want to handle it setting id to selected metric setting id 
    * so whenever category arr change remove  category from categoryWiseMetricChange which are remove by user 
    */

    setCategoryWiseMetricChange((categoryArr) => {
      return categoryArr.filter((cat) => {
        return category.includes(cat);
      });
    });

    setCategoryWiseMetric((categoryWiseMetric) => {
      return category.reduce((cat1, cat2) => {
        cat1[cat2] =
          categoryWiseMetric?.[cat2] ?? metricSettingId ?? DefaultSet;
        return cat1;
      }, {});
    });
  }, [category]);

  /*
   * Adds a category to the list of categories whose template has been
   * manually changed by the user. If the category is already present,
   * it won't be duplicated.
   * updating the state categoryWiseMetricChange
   */
  function categoryWiseTemplateHandle(category) {
    setCategoryWiseMetricChange((categoryList) => {
      return Array.from(new Set([...categoryList, category]));
    });
  }

  /*
   * Updates the selected template for a specific category when the user
   * clicks the settings (gear) icon and chooses a template from the modal.
   * Also tracks that this category's template was explicitly modified.
   *  updating the state categoryWiseMetric
   */
  function CategoryWiseTemplateChangeHandle({ category, value }) {
    if (isTransactionPending) return;
    setCategoryWiseMetric((categoryWise) => {
      return {
        ...categoryWise,
        [category]: value,
      };
    });

    // Mark this category as manually updated
    categoryWiseTemplateHandle(category);
  }

  /*
   * Handles the event when the user selects a different metric setting.
   * 1. Updates the current metricSettingId state.
   * 2. Recomputes the category-wise metric mapping based on the new setting.
   */
  function MetricSettingChangeHandle(id) {
    if (isTransactionPending) return;
    setMetricSettingId(id);
    onMetricSettingChangeSetCategoryWise(id);
  }

  /*
   * Rebuilds the category-wise metric object when a metric setting changes.
   *
   * Logic:
   * - For each category:
   *     - If this category was manually changed earlier (exists in categoryMetricChange),
   *         preserve the user-selected template for that category.
   *     - Otherwise, use the newly selected metric setting ID.
   *     - If no ID is provided, fall back to DefaultSet.
   */
  // function onMetricSettingChangeSetCategoryWise(id) {
  //   setCategoryWiseMetric((categoryWiseMetric) => {
  //     return category.reduce((acc, cat) => {
  //       acc[cat] = categoryMetricChange.includes(cat)
  //         ? categoryWiseMetric?.[cat] // preserve manual change
  //         : id ?? DefaultSet; // use new selected metric setting
  //       return acc;
  //     }, {});
  //   });
  // }
  function onMetricSettingChangeSetCategoryWise(id) {
    // Clear the manual override tracking when global template changes
    setCategoryWiseMetricChange([]);

    setCategoryWiseMetric((categoryWiseMetric) => {
      return category.reduce((acc, cat) => {
        acc[cat] = id ?? DefaultSet;
        return acc;
      }, {});
    });
  }
  // Check if any form field has been modified from initial state
  const hasFormValues =
    auditTransactionId ||
    brand.trim() !== "" ||
    category.length > 0 ||
    llm.length > 1 || llm[0] !== "gpt-5.1" ||
    market.length > 1 || market[0] !== "General Market" ||
    persona.length > 1 || persona[0]?.title !== "General Profile" ||
    Object.keys(competitorsData).length > 0;

  return (
    <>
      <div className={classes.card}>
        <div className={classes.header}>
          <div className={classes.radio}>
            <RadioGroup
              disabled={discoveryCtx.status?.loading}
              options={RADIO_OPTIONS}
              selectedvalue={discoveryCtx.type}
              onChange={handleDiscoveryTypeChange}
            />
          </div>
          <div className={classes.header_actions}>
            {warningText && <Warning text={warningText} />}
            <MUIButton
              variant="outlined"
              size="small"
              onClick={() => {
                setShowHistoryModal(true)
              }}
            >
              <span style={{ marginRight: '6px', fontSize: '14px' }}>🕐</span>
              View History
            </MUIButton>
            <MUIIconButton sx={{ color: "#000", marginTop: "-10px !important" }} onClick={() => setShowConfigModal(true)}>
              <SettingsOutlined />
            </MUIIconButton>
          </div>
        </div>

        <div className={classes.input_group}>
          <div className={classes.input_section}>
            <div className={classes.brand_input}>
              <TextInput
                disabled={!!discoveryCtx?.state?.transactionId}
                fullWidth
                value={brand}
                label={getEntityLabel(discoveryTypeChange)}
                placeholder={discoveryTypeChange === "brand" ? "Hope College" : "Hope College Global Learning Programs"}
                onChange={handleBrandInputChange}
              />
              {loading && <CircularProgress className={classes.loading} size={15} />}
            </div>

            <div style={{ flex: 1 }}>
              <MUIMultiSelect
                disabled={discoveryCtx?.loading || isFinalTransactionCompleted}
                label={"LLM"}
                allowSettingPrimary={true}
                options={discoveryCtx?.loading || isFinalTransactionCompleted ? [llm] : LLM_OPTIONS}
                value={llm || ["gpt-5.1"]}
                customWidth={classes.fullWidth}
                renderSelectedValues={(selected) => {
                  return selected
                    .map((val) => LLM_OPTIONS.find((opt) => opt.value === val)?.name || "gpt-5.1")
                    .join(", ");
                }}
                onRadioChange={handlePrimaryLLMChange}
                selectedPrimary={primaryLLM || "gpt-5.1"}
                onChange={(selected, primary) => {
                  if (selected && selected.length >= 6) {
                    toast.warn("Only 5 LLM selections are allowed");
                    setLLM([...llm]);
                    return;
                  }
                  setLLM(selected);
                  setPrimaryLLM(primary);
                }}
              />
            </div>

            {/* <div style={{ flex: 1 }}>
              <MUIMultiTextInput
                value={market}
                onChange={setMarket}
                label={"Market"}
                onDelete={handleDeleteMarket}
                triggerWarning={() => toast.warn("Only 3 Market selections are allowed")}
                isDisabled={discoveryCtx?.loading || isFinalTransactionCompleted}
              />
            </div> */}
            <div style={{ flex: 1 }}>
              <MUIMultiItemBox
                label="Market"
                value={market}
                onChange={setMarket}
                max={3}
                modalTitle="Add Market"
                modalFields={[
                  { name: "market", label: "Market", required: true },
                ]}
                isDisabled={discoveryCtx?.loading || isFinalTransactionCompleted}
              />
            </div>

            <div style={{ flex: 1 }}>
              <div className={`${classes.columnWithSettings} ${persona?.length > 1 && market.length > 1 ? classes.hasSettings : ""}`}>
                <div style={{ flex: 1 }}>
                  <MUIMultiItemBox
                    label="Persona"
                    value={persona}
                    onChange={setPersona}
                    max={3}
                    labelKey="title"
                    useObjectFormat={true}
                    modalTitle="Add Persona"
                    modalFields={[
                      { name: "title", label: "Title", required: true },
                      { name: "description", label: "Description", required: true, multiline: true }
                    ]}
                    isDisabled={discoveryCtx?.loading || isFinalTransactionCompleted}
                  />
                </div>

              </div>
            </div>
          </div>

          <div className={classes.input_section_with_template}>
            <div style={{ flex: 1 }}>
              <MUIMultiSelect
                loading={isCategorySuggestionLoading}
                allowSettingPrimary={false}
                disabled={discoveryCtx?.loading || isFinalTransactionCompleted}
                source={brand}
                fullWidth
                label="Category"
                allowCustomOption={true}
                customWidth={classes.fullWidth}
                options={discoveryCtx?.loading || isFinalTransactionCompleted ? [category] : [...aICategories]}
                value={category}
                onChange={(selected) => {
                  if (selected && selected.length > 3) {
                    setCategory([...category]);
                    updateCompetitorsByCategories([...category]);
                    toast.warn("Only 3 Category selections are allowed");
                    return;
                  }
                  setCategory(selected);
                  updateCompetitorsByCategories(selected);
                }}
              />

            </div>

            {category?.length > 0 && renderAllCompetitors()}
          </div>

          {/* Action Buttons */}
          <div className={classes.action_buttons}>
            {!isFinalTransactionCompleted && (
              <>
                <MUIButton
                  variant="contained"
                  color={"primary"}
                  disabled={
                    loading ||
                    !category ||
                    !hasRequiredCompetitors ||
                    !hasRequiredLLMs ||
                    discoveryCtx.loading ||
                    isAuditRunning ||
                    isTransactionPending
                  }
                  onClick={() => {
                    setLaunchType("test");
                    setLaunchMessage(true);
                  }}
                >
                  Run Test Audit
                </MUIButton>
                {discoveryCtx?.state?.launchRecord.length > 0 && (
                  <MUIButton
                    variant="contained"
                    color="primary"
                    disabled={
                      loading ||
                      !category ||
                      !hasRequiredCompetitors ||
                      !hasRequiredLLMs ||
                      discoveryCtx.loading ||
                      (isChanged && !discoveryCtx.loading) ||
                      isAuditRunning ||
                      isTransactionPending
                    }
                    onClick={() => {
                      setLaunchType("final");
                      setLaunchMessage(true);
                    }}
                  >
                    Run Final Audit
                  </MUIButton>
                )}
              </>
            )}
            {discoveryCtx.state.finalTransactionStatus !== "COMPLETED" && auditTransactionId && (
              <MUIButton color="error" onClick={() => setShowDeleteDialog(true)}>
                Cancel
              </MUIButton>
            )}
            <MUIButton
              variant="outlined"
              color="primary"
              onClick={cancelTransactionRecord}
              disabled={!hasFormValues}
            >
              Start New
            </MUIButton>
          </div>
        </div>

        <ToastContainer />
      </div>
      {discoveryCtx?.state?.id && (
        <Modal
          handleClose={() => setShowDeleteDialog(false)}
          handleConfirm={deleteTransaction}
          open={showDeleteDialog}
          title="Delete History"
          showActions
          confirmBtnText="Delete"
          confirmBtnColor="error"
        >
          <div className={classes.contentText}>
            {shouldResetOnDelete
              ? `Do you want to delete this item - ${discoveryCtx?.entity}?`
              : `Do you want to delete the record of ${currentTabName} for ${discoveryCtx?.entity}?`
            }
          </div>
        </Modal>
      )}
      {launchMessage && (
        <Modal
          handleClose={() => setLaunchMessage(false)}
          handleConfirm={debounceLaunch}
          open={launchMessage}
          title=""
          confirmBtnText="ok"
          showActions
        >
          <div className={classes.contentText}>
            {launchType === "test" ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: `The Test Audit will be executed using the <b>${testLLMModel}</b> language model. This option is intended solely for trial executions and result verification.`,
                }}
              />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: `
                  This action will begin the Final Audit Launch, Would you like to proceed?
                `,
                }}
              />
            )}
          </div>
        </Modal>
      )}
      <SettingsModal
        open={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        category={category}
        categoryWiseMetric={categoryWiseMetric}
        metricSettingId={metricSettingId}
        onCategoryTemplateChange={CategoryWiseTemplateChangeHandle}
        MetricSettingChangeHandle={MetricSettingChangeHandle}
        personaSettings={personaSettings}
        setPersonaSettings={setPersonaSettings}
        rbiType={rbiType}
        setRbiType={setRbiType}
        keywords={keywords}
        setKeywords={setKeywords}
      />
      <History
        open={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        filter={discoveryCtx.type}
        setCancelTransaction={setCancelTransaction}
        startPolling={startPolling}
        stopPolling={stopPolling}
        processRetry={processRetry}
        setActiveTab={setActiveTab}
        setDomain={setDomain}
        setIsAuditRunning={setIsAuditRunning}
      />
    </>
  );
}

function UserMetricSelect({
  metricSettingId,
  MetricSettingChangeHandle,
  isDisabled,
}) {
  const dispatch = useDispatch();
  const discoveryCtx = useContext(DiscoveryContext);

  const userMetricSetting = useSelector((store) => store.userSet);

  const sideTabOptions =
    userMetricSetting?.data?.map((ele) => {
      return { name: ele.name, value: ele.id, isDefault: ele.isDefault };
    }) ?? [];

  /*clean up Action*/
  useEffect(() => {
    return () => {
      dispatch({ type: "RESET_METRIC" });
    };
  }, []);

  function CustomOption(option) {
    let { name, value, isDefault } = option;
    return (
      <span className={isDefault ? classes.isDefault : classes.isNotDefault}>
        {name}
      </span>
    );
  }

  return (
    <div className={`${classes.columnWithSettings} ${classes.hasSettings}`}>
      <MUISelect
        fullWidth={false}
        optionValue={metricSettingId}
        label={"Template"}
        options={sideTabOptions}
        disabled={isDisabled}
        CustomOption={CustomOption}
        onChange={(e) => {
          MetricSettingChangeHandle(e.target.value);
        }}
      />
      <MUIIconButton
        sx={{ color: "#000" }}
        onClick={() => {
          dispatch({ type: "ACTION_MODEL", payload: true });
        }}
      >
        <SettingsOutlined />
      </MUIIconButton>
    </div>
  );
}

function CategoryTemplateSelect({
  metricSettingId,
  category,
  CategoryWiseTemplateChangeHandle,
  categoryWiseMetric,
}) {
  const userMetricSetting = useSelector((store) => store.userSet);
  const [showModal, setShowModal] = useState(false);

  const sideTabOptions =
    userMetricSetting?.data?.map((ele) => {
      return { name: ele.name, value: ele.id, isDefault: ele.isDefault };
    }) ?? [];

  return (
    <div className={classes.metric_setting}>
      <Modal
        handleClose={() => setShowModal(false)}
        open={showModal}
        title="Category Specific Template Settings"
        confirmBtnText="Delete"
        confirmBtnColor="error"
        width={"700"}
      >
        <ModalContentRender
          categoryWiseMetric={categoryWiseMetric}
          category={category}
          sideTabOptions={sideTabOptions}
          metricSettingId={metricSettingId}
          CategoryWiseTemplateChangeHandle={CategoryWiseTemplateChangeHandle}
        />
      </Modal>

      <MUIIconButton
        sx={{ color: "#000" }}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <SettingsOutlined />
      </MUIIconButton>
    </div>
  );
}

function ModalContentRender({
  category,
  sideTabOptions,
  categoryWiseMetric,
  CategoryWiseTemplateChangeHandle,
  metricSettingId,
}) {
  return (
    <div>
      <div className={classes.templateSet}>
        <div
          style={{ width: "40%", textAlign: "center" }}
          className={classes.Heading}
        >
          {"Category"}
        </div>
        <div
          style={{ flex: "1", textAlign: "center" }}
          className={classes.Heading}
        >
          Template
        </div>
      </div>
      {category.map((ele) => {
        return (
          <div className={classes.templateSet}>
            <div style={{ width: "40%", textAlign: "center" }}>
              <span title={ele} className={classes.text}>
                {ele}
              </span>
            </div>
            <div style={{ flex: "1" }}>
              <MUISelect
                fullWidth={false}
                optionValue={categoryWiseMetric?.[ele] ?? metricSettingId}
                label={""}
                options={sideTabOptions}
                onChange={(e) => {
                  CategoryWiseTemplateChangeHandle({
                    category: ele,
                    value: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
